import { SubscriptionTypeProperties } from "./SubscriptionConstants";

export const SourceId = "locations";
export const ClusterMaxZoom = 14;
export const ClusterRadius = 50;
export const MapDefaultZoom = 10;
export const MapCenter = [51.4, 35.7];

export const GetClusterLayer = {
    id: "clusters",
    type: "circle",
    source: SourceId,
    paint: {
        "circle-color": [
            "step",
            ["get", "point_count"],
            "#c9ffd8",
            5,
            "#a8ffc0",
            50,
            "#87ffa8",
            100,
            "#63d682",
            500,
            "#50b56b",
        ],
        "circle-radius": [
            "step",
            ["get", "point_count"],
            20,
            5,
            25,
            50,
            30,
            100,
            35,
            500,
            40,
        ],
    },
};

export const GetClusterPointsLayer = {
    id: "clustered-point",
    type: "symbol",
    source: SourceId,
    filter: ["has", "point_count"],
    layout: {
        "text-field": ["get", "point_count"],
        "text-font": ["Vazir Regular"],
    },
};

export const UnClusteredPointId = "unclustered-point";

export const GetUnClusterPointsLayer = {
    id: UnClusteredPointId,
    type: "symbol",
    source: SourceId,
    filter: ["!", ["has", "point_count"]],
    layout: {
        "icon-image": [
            "match",
            ["get", "status"],
            1,
            "visited",
            2,
            "new",
            3,
            "viewed",
            4,
            "standard",
            5,
            "enhanced",
            6,
            "ultimate",
            7,
            "ultimate_plus",
            "",
        ],
        "icon-size": 0.5,
        "icon-allow-overlap": true,
    },
};

export const MapIcons = [
    { src: "/images/contain/bonyan_pin.png", id: "new" },
    { src: "/images/pin_visited.png", id: "visited" },
    { src: "/images/pin_viewed.png", id: "viewed" },
    { src: SubscriptionTypeProperties.STANDARD.pinUrl, id: "standard" },
    { src: SubscriptionTypeProperties.ENHANCED.pinUrl, id: "enhanced" },
    { src: SubscriptionTypeProperties.ULTIMATE.pinUrl, id: "ultimate" },
    {
        src: SubscriptionTypeProperties.ULTIMATE_PLUS.pinUrl,
        id: "ultimate_plus",
    },
];
